/* Trinh xem anh phong to cho .htsg-gallery[data-lightbox] — tai hien lightbox cua Squarespace */
(function () {
  var box, img, cap, counter, list = [], idx = 0;
  function full(u) { return (u || '').replace(/([?&])width=\d+/, '$1width=2400'); }
  function build() {
    box = document.createElement('div');
    box.className = 'htsg-lb'; box.hidden = true;
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true');
    var ic = function (d) { return '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
    var L = window.HTSG_T || { close: 'Đóng', prev: 'Ảnh trước', next: 'Ảnh sau' };
    box.innerHTML = '<button class="htsg-lb__close" aria-label="' + L.close + '">' + ic('M6 6l12 12M18 6L6 18') + '</button>' +
      '<button class="htsg-lb__nav htsg-lb__prev" aria-label="' + L.prev + '">' + ic('M15 5l-7 7 7 7') + '</button>' +
      '<figure class="htsg-lb__fig"><img alt=""><figcaption></figcaption></figure>' +
      '<button class="htsg-lb__nav htsg-lb__next" aria-label="' + L.next + '">' + ic('M9 5l7 7-7 7') + '</button>' +
      '<div class="htsg-lb__count"></div>';
    document.body.appendChild(box);
    img = box.querySelector('img'); cap = box.querySelector('figcaption'); counter = box.querySelector('.htsg-lb__count');
    box.querySelector('.htsg-lb__close').onclick = close;
    box.querySelector('.htsg-lb__prev').onclick = function (e) { e.stopPropagation(); show(idx - 1); };
    box.querySelector('.htsg-lb__next').onclick = function (e) { e.stopPropagation(); show(idx + 1); };
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    var sx = null;
    box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1)); sx = null; });
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close(); if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1);
    });
  }
  function show(i) {
    if (!list.length) return;
    idx = (i + list.length) % list.length;
    var f = list[idx], im = f.querySelector('img'), c = f.querySelector('figcaption');
    img.src = full(im.getAttribute('data-full') || im.currentSrc || im.src);
    img.alt = im.alt || '';
    cap.innerHTML = c ? c.innerHTML : ''; cap.hidden = !c;
    counter.textContent = (idx + 1) + ' / ' + list.length;
    box.classList.toggle('htsg-lb--single', list.length < 2);
  }
  function close() { box.hidden = true; document.documentElement.classList.remove('htsg-lb-open'); }
  document.addEventListener('click', function (e) {
    var f = e.target.closest('.htsg-gallery[data-lightbox] figure');
    if (!f || e.target.closest('a')) return;
    e.preventDefault();
    if (!box) build();
    var g = f.closest('.htsg-gallery');
    list = [].slice.call(g.querySelectorAll('figure')).filter(function (x) { return x.querySelector('img') && !x.querySelector('a'); });
    box.hidden = false; document.documentElement.classList.add('htsg-lb-open');
    show(list.indexOf(f));
  });
})();

/* Anh nho trong thu vien (logo 100–300px): khong phong to qua kich thuoc that -> object-fit: scale-down */
(function () {
  function check(im) {
    if (!im.naturalWidth) return;
    var small = im.naturalWidth < im.clientWidth * 0.95 || im.naturalHeight < im.clientHeight * 0.95;
    im.classList.toggle('htsg-img--small', small);
  }
  function all() { document.querySelectorAll('.htsg-gallery figure img').forEach(check); }
  document.addEventListener('load', function (e) { if (e.target.matches && e.target.matches('.htsg-gallery figure img')) check(e.target); }, true);
  document.addEventListener('DOMContentLoaded', all);
  window.addEventListener('load', all);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(all, 150); });
})();

/* Hang the nhieu cot: tieu de h3 cung chieu cao de doan van bat dau cung mot dong */
(function () {
  function eq() {
    document.querySelectorAll('.htsg-rte__body .htsg-row').forEach(function (row) {
      var cols = row.querySelectorAll(':scope > .htsg-col'); if (cols.length < 2) return;
      var hs = []; cols.forEach(function (c) { var h = c.querySelector(':scope > h3'); if (h) { h.style.minHeight = ''; hs.push(h); } });
      if (hs.length < 2 || window.innerWidth < 750) return;
      var max = 0; hs.forEach(function (h) { max = Math.max(max, h.getBoundingClientRect().height); });
      hs.forEach(function (h) { h.style.minHeight = Math.ceil(max) + 'px'; });
    });
  }
  document.addEventListener('DOMContentLoaded', eq);
  window.addEventListener('load', eq);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(eq);
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(eq, 150); });
})();

/* Thanh neo nhanh (trang Du an): danh dau muc dang xem */
(function () {
  function init() {
    var nav = document.querySelector('.htsg-rte--projects .htsg-rte__body > p:has(> a[href^="#"])');
    if (!nav || !('IntersectionObserver' in window)) return;
    nav.classList.add('htsg-anchors');
    var links = [].slice.call(nav.querySelectorAll('a[href^="#"]'));
    var map = {};
    links.forEach(function (a) { var el = document.getElementById(decodeURIComponent(a.hash.slice(1))); if (el) map[el.id] = a; });
    function mark(id) { links.forEach(function (a) { if (map[id] === a) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); }); }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) mark(e.target.id); });
    }, { rootMargin: '-30% 0px -60% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
    if (location.hash && map[location.hash.slice(1)]) mark(location.hash.slice(1));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
